import { ModuleGuard } from './ModuleGuard';
import { PermissionGuard } from './PermissionGuard';
import { SimpleGuard } from './SimpleGuard';

export const ProtectedComponent = {
  ModuleGuard,
  SimpleGuard,
  PermissionGuard,
};
